import React from "react";
import {react} from "mobx";
import {inject, observer} from "mobx-react";
import {Button, Col, Form, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row} from "reactstrap";
import {Component} from "react/lib/ReactBaseClasses";
import {toast} from "react-toastify";
import _ from 'lodash';
import {Link} from "react-router-dom";
import {ModalForm} from "./ModalForm";
import {Validacao} from "./Validacao";
import Select from "react-select";
import PropTypes from "prop-types";
import loading from '../../../assets/images/ajax-loader.gif';
import {FluxoModalForm} from "./FluxoModalForm";

@inject("store")
@observer
class FormWithActions extends Component {

    static propTypes = {
        taskId: PropTypes.string,
        tarefa: PropTypes.string,
        fluxo: PropTypes.string,
        solicitacaoExcecao: PropTypes.bool,
        possiveisAcoes: PropTypes.object
    };

    constructor(props) {
        super(props);
        this.modalStore = this.props.store.modalStore;
        this.formStore = this.props.store.formStore;
        this.validacaoStore = this.props.store.validacaoStore;
        this.controller = this.props.controller;
    }

    componentWillMount() {
        this.modalStore.setSubmitted(false);
        this.modalStore.setSubmitMensagemErro("");
        this.formStore.setSubmitted(false);
        this.formStore.setSubmitMensagemErro("");
    }

    modalForm() {
        if (this.modalStore.exibirModal.aberto) {
            let cabecalho;
            let botoes;
            let corpo;
            switch (this.modalStore.exibirModal.tipo) {
                case 'demandarAjustes':
                    cabecalho = "Solicitação: Demandar ajustes";
                    botoes = this.botoesModalDemandarAjustes();
                    break;
                case 'rejeitar':
                    cabecalho = "Solicitação: Reprovar";
                    botoes = this.botoesModalRejeitar();
                    break;
                case 'aprovar':
                    cabecalho = "Solicitação: Aprovar";
                    botoes = this.botoesModalAprovar();
                    break;
                case 'enviar':
                    cabecalho = "Solicitação: Enviar";
                    botoes = this.botoesModalEnviar();
                    break;
                case 'enviarAprovacao':
                    cabecalho = "Horas trabalhadas: Enviar para aprovação";
                    botoes = this.botoesModalEnviarAprovacao();
                    corpo = this.mensagemConfirmaEnvioHorasExtras();
                    break;
                case 'enviarPagamento':
                    cabecalho = "Pagamento: Enviar";
                    botoes = this.botoesModalEnviarPagamento();
                    corpo = this.mensagemConfirmaEnvioPagamento();
                    break;
                case 'desistir':
                    cabecalho = "Solicitação: Desistir";
                    botoes = this.botoesModalDesistir();
                    break;
                case 'reivindicar':
                    cabecalho = "Solicitação: Reivindicar alocação";
                    botoes = this.botoesModalReivindicar();
                    break;
                case 'cancelar':
                    cabecalho = "Solicitação: Cancelar";
                    botoes = this.botoesModalCancelar();
                    break;
                case 'confirmarAlocacao':
                    cabecalho = "Solicitação: Confirmar alocação";
                    botoes = this.botoesModalConfirmarAlocacao();
                    break;
                case 'confirmarContratacao':
                    cabecalho = "Solicitação: Confirmar contratação";
                    botoes = this.botoesModalConfirmarContratacao();
                    break;
                case 'anteciparTermino':
                    cabecalho = "Solicitação: Antecipar término";
                    botoes = this.botoesAnteciparTermino();
                    corpo = this.mensagemConfirmaTerminoAntecipado();
                    break;
                case 'substituir':
                    cabecalho = "Solicitação de substituição: Enviar";
                    botoes = this.botoesSubstituir();
                    corpo = this.mensagemConfirmaSolicitacaoSubstituicao();
                    break;
                case 'migrar':
                    cabecalho = "Solicitação de migração: Enviar";
                    botoes = this.botoesMigrar();
                    corpo = this.mensagemConfirmaSolicitacaoMigracao();
                    break;
                case 'prorrogar':
                    cabecalho = "Solicitação: Prorrogar";
                    botoes = this.botoesProrrogar();
                    corpo = !this.props.controller.exibeAprovadoresExtraDetalhamento && this.mensagemConfirmaSolicitacaoProrrogacao();
                    break;
                case 'informarNovoRecurso':
                    cabecalho = "Solicitação: Informar novo recurso";
                    botoes = this.botoesInformarNovoRecurso();
                    break;
                case 'solicitaTerminoAntecipado':
                    cabecalho = "Solicitação: Término antecipado";
                    botoes = this.botoesSolicitacaoTerminoAntecipado();
                    corpo = this.mensagemConfirmarTerminoAntecipadoDeSolicitacaoSubstituicao();
                    break;
                case 'forcarAprovacao':
                    cabecalho = "Solicitação: Forçar aprovação";
                    botoes = this.botoesModalForcarAprovacao();
                    break;
            }
            return corpo ? <ModalForm corpo={corpo} cabecalho={cabecalho} botoes={botoes}/> : <FluxoModalForm fluxoController={this.props.controller} cabecalho={cabecalho} botoes={botoes}/>;
        }
    }

    mensagemConfirmarTerminoAntecipadoDeSolicitacaoSubstituicao = () => {
        return (
            <span>Deseja cancelar fluxo de substituição e iniciar fluxo de término antecipado?</span>
        )
    };

    mensagemConfirmaTerminoAntecipado = () => {
        return (
            <span>Confirma a solicitação de término antecipado?</span>
        )
    };

    mensagemConfirmaSolicitacaoSubstituicao = () => {
        return (
            <span>Confirma a solicitação de substituição?</span>
        )
    };

    mensagemConfirmaSolicitacaoMigracao = () => {
        return (
            <span>Confirma a solicitação de migração?</span>
        )
    }

    mensagemConfirmaSolicitacaoProrrogacao = () => {
        return (
            <span>Confirma a solicitação de prorrogação?</span>
        )
    };

    mensagemConfirmaEnvioHorasExtras = () => {
        return (
            <span>Confirma o lançamento de horas trabalhadas?</span>
        )
    };

    mensagemConfirmaEnvioPagamento = () => {
        return (
            <span>Confirma o envio de pagamento?</span>
        )
    };

    solicitarTerminoAntecipado = () => {
        this.props.controller.toggleIrParaSolicitacaoTerminoAntecipado();
        this.modalStore.toggleModal();
    };


    salvarTimesheet = () => this.salvarDados((...props) => this.props.controller.salvarTimesheet(...props), 'Horas trabalhadas salvas');

    salvarDados = (funcaoTramitacao, mensagemSucesso) => {
        funcaoTramitacao().then(response => {
            toast.success(mensagemSucesso);
        }).catch(error => {
            console.log(error && error.response ? error.response : error);
        });
    };

    demandarAjustes = () => this.tramitarETratarResultado((...props) => this.props.controller.demandarAjustes(...props), 'Solicitação enviada para ajuste');

    rejeitar = () => this.tramitarETratarResultado((...props) => this.props.controller.rejeitar(...props), 'Solicitação reprovada');

    aprovar = () => this.tramitarETratarResultado((...props) => this.props.controller.aprovar(...props), 'Solicitação aprovada');

    enviar = () => this.tramitarETratarResultado((...props) => this.props.controller.enviar(...props), 'Solicitação enviada');

    forcarAprovacao = () => this.tramitarETratarResultado((...props) => this.props.controller.forcarAprovacao(...props), 'Solicitação aprovada');

    enviarAprovacao = () => this.tramitarETratarResultado((...props) => this.props.controller.enviarAprovacao(...props), 'Horas extras enviadas para aprovação');

    enviarPagamento = () => this.tramitarETratarResultado((...props) => this.props.controller.enviarPagamento(...props), 'Pagamento enviado');

    desistir = () => this.tramitarETratarResultado((...props) => this.props.controller.desistir(...props), 'Desistência registrada');

    reivindicar = () => this.tramitarETratarResultado((...props) => this.props.controller.reivindicar(...props), 'Alocação reivindicada');

    cancelar = () => this.tramitarETratarResultado((...props) => this.props.controller.cancelar(...props), 'Solicitação cancelada!');

    confirmarAlocacao = () => this.tramitarETratarResultado((...props) => this.props.controller.confirmarAlocacao(...props), 'Alocação confirmada');

    confirmarContratacao = () => this.tramitarETratarResultado((...props) => this.props.controller.confirmarContratacao(...props), 'Contratação confirmada');

    anteciparTermino = () => this.tramitarETratarResultado((...props) => this.props.controller.anteciparTermino(...props), "Solicitação de término antecipado", false, true);

    substituir = () => this.tramitarETratarResultado((...props) => this.props.controller.substituir(...props), 'Solicitação de substituição', false, true);

    migrar = () => this.tramitarETratarResultado((...props) => this.props.controller.migrar(...props), 'Solicitação de migração', false, true, 'Migração confirmada');

    prorrogar = () => this.tramitarETratarResultado((...props) => this.props.controller.prorrogar(...props), 'Solicitação de prorrogação', false, true, "Ajuste de solicitação de prorrogação enviado");

    informarNovoRecurso = () => this.tramitarETratarResultado((...props) => this.props.controller.informarNovoRecurso(...props), 'Substituição confirmada');

    tramitarETratarResultado = (funcaoTramitacao, mensagemSucesso, autoClose = true, withId = false, mensagemAjuste) => {
        this.modalStore.setSubmitted(true);
        this.modalStore.setSubmitMensagemErro("");
        if (this.validacaoStore.isValidForm && !this.modalStore.loading) {
            this.modalStore.loading = true;
            funcaoTramitacao(this.props.taskId).then(response => {
                //console.log(response);
                if(withId) {
                    this.props.controller.solicitacao.id = response.data.id;
                    if(response.data.id) {
                        toast.success(`${mensagemSucesso} ${this.props.controller.solicitacao.id} enviada`, {autoClose});
                    } else {
                        toast.success(mensagemAjuste);
                    }
                } else {
                    toast.success(mensagemSucesso);
                }
                this.modalStore.toggleModal();
                this.formStore.toggleAcaoEnviada();
            }).catch(error => {
                console.log(error);

                this.modalStore.setSubmitMensagemErro(error.response.data.message);
                this.modalStore.loading = false;
            });
        }
    };



    botoesModalDemandarAjustes = () => this.botoesModal(this.demandarAjustes);

    botoesModalRejeitar = () => this.botoesModal(this.rejeitar);

    botoesModalAprovar = () => this.botoesModal(this.aprovar);

    botoesModalEnviar = () => this.botoesModal(this.enviar);

    botoesModalForcarAprovacao = () => this.botoesModal(this.forcarAprovacao);

    botoesModalEnviarAprovacao = () => this.botoesModal(this.enviarAprovacao);

    botoesModalEnviarPagamento = () => this.botoesModal(this.enviarPagamento);

    botoesModalDesistir = () => this.botoesModal(this.desistir);

    botoesModalReivindicar = () => this.botoesModal(this.reivindicar);

    botoesModalCancelar = () => this.botoesModal(this.cancelar);

    botoesModalConfirmarAlocacao = () => this.botoesModal(this.confirmarAlocacao);

    botoesModalConfirmarContratacao = () => this.botoesModal(this.confirmarContratacao);

    botoesAnteciparTermino = () => this.botoesModal(this.anteciparTermino);

    botoesSubstituir = () => this.botoesModal(this.substituir);

    botoesMigrar = () => this.botoesModal(this.migrar)

    botoesProrrogar = () => this.botoesModal(this.prorrogar);

    botoesInformarNovoRecurso = () => this.botoesModal(this.informarNovoRecurso);

    botoesSolicitacaoTerminoAntecipado = () => this.botoesModal(this.solicitarTerminoAntecipado);

    botoesModal = (handler) => <div>
        <Button color="primary" onClick={handler} disabled={this.modalStore.loading}>Confirmar</Button>
        <Button color="secondary" onClick={() => {
            this.modalStore.toggleModal();
            this.validacaoStore.desabilitarValidacao = false;
        }} disabled={this.modalStore.loading}>Cancelar</Button>
    </div>;

    voltar() {
        window.history.back();
    }

    actionToolBar() {
        return (
            <Row>

                <Col xs={12} md={4}>
                    {this.props.controller.idSolicitacaoExibicao ? (
                    <h4 className="align-top">Solicitação: {this.props.controller.idSolicitacaoExibicao}</h4>
                    ): ""}
                </Col>
                <Col xs={12} md={8}>
                    <div className="form-buttons">
                        {/*<Link to="/solicitacoes-pendentes" className="btn btn-secondary">Voltar</Link>{' '}*/}
                        <Button onClick={() => this.voltar()}>Voltar</Button>{' '}
                        {this.props.possiveisAcoes.includes('SOLICITA_TERMINO_ANTECIPADO') &&
                        <Button onClick={() => this.openModal('solicitaTerminoAntecipado')}>Solicitar término antecipado</Button>}{' '}
                        {this.props.possiveisAcoes.includes('SALVAR_TIMESHEET') &&
                        <Button onClick={() => this.salvarTimesheet()}>Salvar</Button>}{' '}
                        {(this.props.possiveisAcoes.includes('AJUSTE') || this.props.possiveisAcoes.includes('DEMANDAR-AJUSTE')) &&
                        <Button onClick={() => this.openModal('demandarAjustes')}>Demandar ajustes</Button>}{' '}
                        {(this.props.possiveisAcoes.includes('REJECT') || this.props.possiveisAcoes.includes('REPROVAR')) &&
                        <Button color='danger' onClick={() => this.openModal('rejeitar')}>Reprovar</Button>}{' '}
                        {(this.props.possiveisAcoes.includes('APPROVE') || this.props.possiveisAcoes.includes('APROVAR')) &&
                        <Button color="primary" onClick={() => this.openModal('aprovar')}>Aprovar</Button>}{' '}
                        {this.props.possiveisAcoes.includes('FORCE_APPROVE') &&
                        <Button color="danger" onClick={() => this.openModal('forcarAprovacao')}>Forçar aprovação</Button>}{' '}
                        {this.props.possiveisAcoes.includes('REIVINDICAR') &&
                        <Button color="primary" onClick={() => this.openModal('reivindicar')}>Reivindicar
                            alocação</Button>}{' '}
                        {this.props.possiveisAcoes.includes('CANCELAR_TIMESHEET') &&
                        <Button color="danger" onClick={() => this.openModal('cancelar')}>Cancelar</Button>}{' '}
                        {this.props.possiveisAcoes.includes('CANCELAR') &&
                        <Button color="danger" onClick={() => this.openModal('cancelar')}>Cancelar
                            solicitação</Button>}{' '}
                        {this.props.possiveisAcoes.includes('DESISTIR') &&
                        <Button color="danger" onClick={() => this.openModal('desistir')}>Desistir</Button>}{' '}
                        {this.props.possiveisAcoes.includes('ENVIAR') &&
                        <Button color="primary" onClick={() => this.openModal('enviar')}>Enviar</Button>}{' '}
                        {this.props.possiveisAcoes.includes('ENVIAR_APROVACAO') &&
                        <Button color="primary" onClick={() => this.openModal('enviarAprovacao')}>Enviar para aprovação</Button>}{' '}
                        {this.props.possiveisAcoes.includes('ENVIAR_PAGAMENTO') &&
                        <Button color="primary" onClick={() => this.openModal('enviarPagamento')}>Enviar</Button>}{' '}
                        {this.props.possiveisAcoes.includes('CONFIRMAR_ALOCACAO') &&
                        <Button color="primary" onClick={() => this.openModal('confirmarAlocacao')}>Confirmar
                            alocação</Button>}{' '}
                        {this.props.possiveisAcoes.includes('CONFIRMAR_CONTRATACAO') &&
                        <Button color="primary" onClick={() => this.openModal('confirmarContratacao')}>Confirmar
                            contratação</Button>}{' '}
                        {this.props.possiveisAcoes.includes('ANTECIPAR_TERMINO') &&
                        <Button color="primary" onClick={() => this.openModal('anteciparTermino')}>Antecipar término</Button>}{' '}
                        {this.props.possiveisAcoes.includes('SUBSTITUIR') &&
                        <Button color="primary" onClick={() => this.openModal('substituir')}>Enviar</Button>}{' '}
                        {this.props.possiveisAcoes.includes('MIGRAR') &&
                        <Button color="primary" onClick={() => this.openModal('migrar')}>Migrar</Button>}{' '}
                        {this.props.possiveisAcoes.includes('PRORROGAR') &&
                        <Button color="primary" onClick={() => this.openModal('prorrogar')}>Prorrogar</Button>}{' '}
                        {this.props.possiveisAcoes.includes('CONFIRMAR_SUBSTITUICAO') &&
                        <Button color="primary" onClick={() => this.openModal('informarNovoRecurso')}>Confirmar substituição</Button>}{' '}
                    </div>
                </Col>
            </Row>
        );
    }

    openModal(tipo) {
        this.props.controller.setObservacoes("")
        if (tipo === "rejeitar" || tipo === "cancelar" || tipo === "desistir")
            this.validacaoStore.desabilitarValidacao = true;

        this.formStore.setSubmitted(true);
        this.formStore.setSubmitMensagemErro("");
        this.formStore.setNomeAcao(tipo);
        if(tipo === 'aprovar' && this.props.controller.solicitacao) {
            this.controller.solicitacao.matriculaAprovadoresExtra = [""];
        }
        if (this.props.possiveisAcoes.includes("CANCELAR", "CANCELAR_TIMESHEET", "DESISTIR") || this.validacaoStore.isValidForm || this.validacaoStore.desabilitarValidacao) {
            this.modalStore.toggleModal(tipo);
        }
    }

    renderChildren = () => {
        return React.Children.map(this.props.children, (child, index) => {
            if (child) {
                return React.cloneElement(child, {
                    key: index,
                    solicitacaoExcecao: this.props.solicitacaoExcecao,
                    controller: this.props.controller,
                    tarefa: this.props.tarefa,
                    fluxo: this.props.fluxo
                })
            }
        });
    };

    error() {
        return (
            <Row>
                <Col xs={12} md={12}>
                    <br/>
                    <div className="form-buttons">
                        <span style={{color: 'red'}}>Existem dados inválidos no formulário. Favor corrigi-los antes de prosseguir.</span>
                    </div>
                </Col>
            </Row>);
    }

    render() {
        return (
            <div>
                {this.actionToolBar()}
                {this.props.error ? this.error() : ''}
                {this.renderChildren()}
                <br/>
                {this.actionToolBar()}
                {this.props.error ? this.error() : ''}
                {this.modalForm()}
            </div>
        );
    }
}

export {FormWithActions}